




import { Component, Vue, Prop } from 'vue-property-decorator'
import { CustomerManagementState } from '@/modules/customermanagement/store'
import StandardSideNav from '@/modules/shared/components/StandardSideNav.vue'
import { AuthState } from '@/modules/auth/store'
import routeToMenu from '@/router/helper'
import custRoutes from '@/modules/customermanagement/routes'
import { IStringIndexed } from '@/modules/shared/types'

@Component({
  components: {
    'standard-sidenav': StandardSideNav
  }
})
export default class SideNav extends Vue {
  private get menu () {
    return routeToMenu(this.navKey, custRoutes)
  }

  private get navKey () {
    if (!(this.$route.matched[0].props as IStringIndexed).nav) {
      return 'root'
    }

    return (this.$route.matched[0].props as IStringIndexed).nav.key as string || 'root'
  }

  private get navWidth () {
    if (!(this.$route.matched[0].props as IStringIndexed).nav) {
      return 175
    }

    return (this.$route.matched[0].props as IStringIndexed).nav.width as string || 175
  }
}
